import { useContext } from 'react';

import { AuthContext } from 'contexts/AuthContext';

export default function useCurrentUser() {
  const authContext = useContext(AuthContext);
  return authContext.currentUser;
}
